// extracted by mini-css-extract-plugin
export default {"switchLabel":"WebSwitch_switchLabel__Crb0m","switcher":"WebSwitch_switcher__JOYCS"};